import React, { ChangeEvent } from 'react'
import * as R from 'ramda'

import { Constant, QuestionAnswerInput, SentenceFormatter } from '../../types'
import { getConstantName } from '../../utils'
import { formatDate } from '../../utils/dateUtils'
import { getSentence } from '../../utils/languageUtils'
import Calendar from '../inputs/calendar/Calendar'
import PuiTextArea from '../inputs/PuiTextArea'

export enum QuestionInputType {
  TEXT_BOX = 'Text box',
  DATE_SELECTOR = 'Date selector',
}

export const QuestionInputsMap = {
  [QuestionInputType.TEXT_BOX]: {
    Component: <PuiTextArea key="textarea" minRows={1} />,
    getValue: (event: ChangeEvent<HTMLInputElement>) => event.target.value,
    getDisplayValue: (input: QuestionAnswerInput) => R.prop('value', input),
    order: 1,
  },
  [QuestionInputType.DATE_SELECTOR]: {
    Component: <Calendar key="calendar" />,
    getValue: R.identity,
    getDisplayValue: (input: QuestionAnswerInput) =>
      formatDate(R.prop('value', input)),
    order: 2,
  },
}

export const getQuestionInputMap = (
  inputTypeId: string,
  AnswerInputTypes: Constant[],
) => {
  const constantName = getConstantName(
    inputTypeId,
    AnswerInputTypes,
  ) as keyof typeof QuestionInputsMap
  return QuestionInputsMap[constantName]
}

type GetMultipleAnswerDisplayValue = {
  AnswerInputTypes: Constant[]
  inputs: QuestionAnswerInput[]
  text: string | null
}

export const getMultipleAnswerDisplayValue = ({
  AnswerInputTypes,
  inputs,
  text,
}: GetMultipleAnswerDisplayValue) => {
  const inputsTextObj = inputs.map(input => {
    const { getDisplayValue, order } = getQuestionInputMap(
      input.inputTypeId,
      AnswerInputTypes,
    )

    return {
      displayValue: getDisplayValue(input),
      order,
    }
  })

  const sortedInputsText = R.sortBy(R.prop('order'))(inputsTextObj)

  return getSentence(
    [text, ...R.pluck('displayValue', sortedInputsText)],
    SentenceFormatter.REGULAR,
    ' | ',
  )
}
